import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { axiosWithAuth } from "../../../../../api/axiosConfig";
import { urlGetDepositos } from "../../../../../api/URLs/mantenimiento";
import CustomAlertMsj from "../../../../../components/Tools/Basics/CustomAlertMsj";
import CustomBtn from "../../../../../components/Tools/Basics/CustomBtn";
import TableMain2 from "../../../../../components/Tools/Tables/TableMain2/TableMain2";

const DepositosModal = ({ show, handleClose }) => {
  const [depositos, setDepositos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [nombreDeposito, setNombreDeposito] = useState("");
  const [editId, setEditId] = useState(null);
  const [alert, setAlert] = useState({ state: 0, msj: "", type: "" });

  const fetchDepositos = async () => {
    setLoading(true);
    try {
      const res = await axiosWithAuth.get(urlGetDepositos);
      setDepositos(res.data);
    } catch (error) {
      setAlert({ state: 2, msj: "Error al obtener depósitos", type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchDepositos();
      setAlert({ state: 0, msj: "", type: "" });
      setNombreDeposito("");
      setEditId(null);
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombreDeposito.trim()) return;

    try {
      setLoading(true);
      if (editId) {
        await axiosWithAuth.put(urlGetDepositos, {
          id: editId,
          nombre: nombreDeposito,
        });
        setAlert({
          state: 2,
          msj: "Depósito actualizado exitosamente",
          type: "success",
        });
      } else {
        await axiosWithAuth.post(urlGetDepositos, { nombre: nombreDeposito });
        setAlert({
          state: 2,
          msj: "Depósito creado exitosamente",
          type: "success",
        });
      }
      setNombreDeposito("");
      setEditId(null);
      fetchDepositos();
    } catch (error) {
      setAlert({
        state: 2,
        msj: "Error al guardar el depósito",
        type: "danger",
      });
      setLoading(false);
    }
  };

  const handleEdit = (dep) => {
    setEditId(dep.id);
    setNombreDeposito(dep.nombre);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("¿Está seguro de eliminar este depósito?")) return;
    try {
      setLoading(true);
      await axiosWithAuth.delete(`${urlGetDepositos}/${id}`);
      setAlert({
        state: 2,
        msj: "Depósito eliminado exitosamente",
        type: "success",
      });
      fetchDepositos();
    } catch (error) {
      setAlert({ state: 2, msj: "Error al eliminar depósito", type: "danger" });
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Gestionar Depósitos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {alert.state === 2 && (
          <CustomAlertMsj alertMsj={alert.msj} alertType={alert.type} />
        )}

        <Form
          onSubmit={handleSubmit}
          className="mb-4 d-flex align-items-end gap-2"
        >
          <Form.Group flex="1" style={{ flex: 1 }}>
            <Form.Label>
              {editId ? "Editar Depósito" : "Nuevo Depósito"}
            </Form.Label>
            <Form.Control
              type="text"
              value={nombreDeposito}
              onChange={(e) => setNombreDeposito(e.target.value)}
              placeholder="Nombre del depósito"
              required
            />
          </Form.Group>
          <Button
            type="submit"
            variant="success"
            disabled={loading}
            className="text-nowrap"
          >
            <i className={editId ? "bi bi-pencil" : "bi bi-plus-lg"} />

            {editId ? " Guardar" : " Agregar"}
          </Button>
          {editId && (
            <Button
              variant="secondary"
              onClick={() => {
                setEditId(null);
                setNombreDeposito("");
              }}
            >
              Cancelar
            </Button>
          )}
        </Form>

        <TableMain2
          data={depositos}
          title={"Depósitos"}
          columns={[
            { header: "Nombre", field: "nombre" },
            { header: "Eliminado", field: "eliminado", formater: "boolean" },

            {
              body: (dep) => (
                <div className="d-flex justify-content-center gap-2">
                  <CustomBtn
                    type="edit_table"
                    onClick={() => handleEdit(dep)}
                  />
                  <CustomBtn
                    type="delete_table"
                    onClick={() => handleDelete(dep.id)}
                  />
                </div>
              ),
            },
          ]}
          loading={loading}
          textFilter
          sortField={"nombre"}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DepositosModal;
